import type { FeatureWithIDs, LayerId } from '../baseadapter';
import type {
  ArcgisMapServerConfig,
  ArcGISAdapterProps
} from './ArcgisMapAdapter';

export type LayerDetails =
  | {
      type: 'LAYER_DETAILS';
      layerId: number;
      layerName: string;
    }
  | {
      type: 'LAYER_ID';
      layerId: number;
    };
export function mapToInternalFeature(
  feature: GeoJSON.Feature,
  layerDetails: LayerDetails,
  serverConfig: ArcgisMapServerConfig
): FeatureWithIDs<ArcGISAdapterProps> {
  const featureType = feature.properties?.[serverConfig.typeField];
  return {
    ...feature,
    gc: {
      layerId: layerDetails.layerId,
      layerName:
        layerDetails.type === 'LAYER_DETAILS'
          ? layerDetails.layerName
          : undefined,
      objectId: feature.properties?.[serverConfig.arcgisIdField] as number,
      type: featureType,
      title: getFeatureTitle(
        serverConfig,
        featureType,
        feature.properties || {}
      ),
      globalId: feature.properties?.[serverConfig.domainIdField]
    },
  };
}

export const Feature = {
  attributeOf <T>(feature: FeatureWithIDs, key: string) {
    const sanitizedKey = key.toLowerCase();
    const properties = feature.properties || {};
    const sanitizedProperties = 
      Object.fromEntries(
        Object.entries(properties).map(([k, v]) => [k.toLowerCase(), v])
      );
    const value = sanitizedProperties[sanitizedKey];
    return value === undefined ? null : (value as T);
  }  
}

const getFeatureTitle = (
  serverConfig: ArcgisMapServerConfig,
  featureType: number,
  featureProperties: Record<string, string | null> | undefined
): string | undefined => {
  if (!featureProperties) return undefined;
  const titleByFeatureType = {
    [featureType]: 'Description',
    DEFAULT: serverConfig.titleField
  };

  const title =
    featureProperties[titleByFeatureType[featureType]] ||
    featureProperties[titleByFeatureType.DEFAULT];

  return title as unknown as string | undefined;
};
